"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const colorToFilter_1 = require("./colorToFilter/colorToFilter");
const filterToColor_1 = require("./filterToColor/filterToColor");
class CssFilterConverter {
    static rgbToFilter(rgbString, options) {
        return colorToFilter_1.ColorToFilter.rgbToFilter(rgbString, options);
    }
    static hexToFilter(hexString, options) {
        return colorToFilter_1.ColorToFilter.hexToFilter(hexString, options);
    }
    static hslToFilter(hslString, options) {
        return colorToFilter_1.ColorToFilter.hslToFilter(hslString, options);
    }
    static keywordToFilter(keyword, options) {
        return colorToFilter_1.ColorToFilter.keywordToFilter(keyword, options);
    }
    static async filterToHex(filterString) {
        return filterToColor_1.FilterToColor.filterToHex(filterString);
    }
    static async filterToRgb(filterString, options) {
        return filterToColor_1.FilterToColor.filterToRgb(filterString, options);
    }
    static async filterToHsl(filterString, options) {
        return filterToColor_1.FilterToColor.filterToHsl(filterString, options);
    }
}
exports.default = CssFilterConverter;
module.exports = CssFilterConverter;
